module.exports = __webpack_public_path__ + "static/media/closed-eyed.3d28df51.svg";